import { Box, BoxProps, ButtonNew, ColorOptions, IconNew as Icon, ModBox, Spacer, TextNew as Text } from '@jfs/ui-new'
import { isEmptyObject } from '@jfs/utils'
import { useCallback, useState } from 'react'
import XlsxPopulate from 'xlsx-populate'

const inputBoxConfig = {
  element: document.createElement('input'),
  type: 'file',
}

const columns = () => {
  return [
    'Name',
    'Mobile',
    'Email',
    'Beneficiary type',
    'Bank A/c',
    'IFSC',
    'Account type',
    'addressLine1',
    'addressLine2',
    'addressLine3',
    'addressLine4',
    'addressRole',
    'phone1',
    'phone2',
    'emailAddr',
    'fax',
    'addressType',
    'pincode',
    'city',
    'state',
    'stateAbbrev',
    'countryCode',
    'country',
    'latitude',
    'longitude',
    'geoCode',
  ]
}

interface FileSelectorProps {
  onFileSelect: any
  onError: (err: string) => void
  mid: string
  resetState: any
  onHandleCancelChangeFile: any
  onHandleAddBeneficiaries: any
}

const BulkBeneficiaryFileSelector = ({
  onFileSelect,
  mid,
  onError,
  resetState,
  onHandleCancelChangeFile,
  onHandleAddBeneficiaries,
}: FileSelectorProps) => {
  const [fileName, setFileName] = useState('')
  const [fileSelected, setSelectedFile] = useState(null)

  const setData = useCallback(
    (name: string, fileSize: number, file: File) => onFileSelect(name, fileSize, file),
    [onFileSelect],
  )

  const onDragStart = (e: any) => {
    e.preventDefault()
  }

  const onDragOver = (e: any) => {
    e.preventDefault()
  }

  const onDrop = (e: any) => {
    e.preventDefault()
    const fileIn = (e.dataTransfer.files as FileList)[0]
    checkValidateProcessFile(fileIn, setData, e.target)
  }

  const checkColumnsAreValid = async (file: any) => {
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file).then(function (workbook) {
        const sheet = workbook.sheet(0)
        const rows = sheet._rows
        const keys: any = []
        const values: any = []
        rows.forEach((row: any, rowIndex: number) => {
          const obj: any = {}
          row._cells.forEach((cell: any, index: number) => {
            if (rowIndex === 1) {
              keys.push(`${cell.value()}`)
            } else {
              const key = keys[index - 1]
              obj[key] = `${cell.value()}`
            }
          })
          !isEmptyObject(obj) && values.push(obj)
        })
        const mismatchedColumns =
          columns().length === keys.length ? columns().filter((item, index) => item !== keys[index]) : columns()
        if (mismatchedColumns?.length === 0) {
          console.log('workbook', workbook)
          console.log('values', values)
          resolve(values)
          setSelectedFile(file)
          setFileName(file?.name)
        } else {
          reject('Invalid File')
          onError('Invalid File')
        }
      })
    })
    try {
      await readPromise
    } catch (e) {
      //setMessage(e, MessageTypes.ERROR)
    }
  }

  const checkValidateProcessFile = (fileChosen: File, setDataCallBack: any, event: any) => {
    if (fileChosen && fileChosen?.name) {
      // Check for filesize 5mb
      if (fileChosen.size < 5242880) {
        checkColumnsAreValid(fileChosen)
      } else {
        onError('File too huge, Please select a file with size <= 5MB')
      }
    }
    if (event) {
      event.value = ''
    }
  }

  const selectFileButtonPressed = (): void => {
    const inputBox = inputBoxConfig.element
    inputBox.type = inputBoxConfig.type
    inputBox.accept = '.csv, .xls, .xlsx'
    inputBox.draggable = true
    inputBox.className = 'inputFileClass'
    inputBox.click()
    inputBox.onchange = (e: Event): void => {
      const target = e.target as HTMLInputElement
      const fileIn = (target.files as FileList)[0]
      checkValidateProcessFile(fileIn, setData, e.target)
    }
  }

  const onCancel = () => {
    resetState && resetState()
  }
  const onAddBeneficiaries = () => {
    setData(fileSelected?.name ?? '', fileSelected?.size ?? 0, fileSelected)
    onHandleAddBeneficiaries && onHandleAddBeneficiaries()
  }

  const onClearFile = () => {
    onHandleCancelChangeFile && onHandleCancelChangeFile()
  }

  return (
    <div draggable={true} onDragStart={onDragStart} onDragOver={onDragOver} onDrop={onDrop}>
      <Box {...styles.container} onPress={selectFileButtonPressed} testID={'selectBulkBeneficiaryFileToUpload'}>
        <Box {...styles.addContainer}>
          <Icon id={'ADD'} color={'WHITE'} size={24} />
        </Box>
        <Spacer size={24} direction={'vertical'} />
        <Box direction="row">
          <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
            {'Drag & Drop or'}
          </Text>
          <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLUE'}>
            {' Choose file '}
          </Text>
          <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
            {'to upload'}
          </Text>
        </Box>
        <Text fontFamily={'jiotype-medium'} fontSize={12} color={'#202F4D80' as ColorOptions}>
          {'CSV or XLS or XLSX file supported'}
        </Text>
      </Box>
      <ModBox
        show={fileName?.length > 0}
        w={'100%'}
        backgroundColor={'#F2F6FF' as ColorOptions}
        borderWidth={1}
        borderColor={'#E0E0E0' as ColorOptions}
        borderRadius={4}
        h={44}
        direction="row"
        justifyContent={'space-between'}
        alignItems={'center'}
        paddingHorizontal={16}
        marginVertical={16}>
        <Box alignItems={'flex-start'} direction="row">
          <Box position={'absolute'} top={-10} left={-4}>
            <Icon id="SUCCESSFUL_FILLED" color={'GREEN'} size={'SMALL'} />
          </Box>
          <Icon id="DOCUMENT" color={'BLACK_21'} size={'BIG'} />
          <Spacer size={16} direction={'horizontal'} />
          <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'} title={fileName ?? ''} />
        </Box>
        <Box alignItems={'flex-end'} onPress={onClearFile} testID="clear-file">
          <Icon id="CLOSE" color={'BLACK_21'} size={'SMALL'} />
        </Box>
      </ModBox>
      <Box w={'100%'} alignItems={'flex-end'} justifyContent={'flex-end'} direction="row" marginVertical={16}>
        <ButtonNew
          onPress={onCancel}
          borderColor={'BLUE'}
          borderWidth={1}
          borderRadius={4}
          color={'WHITE'}
          title={'Cancel'}
          titleColor={'BLUE'}
          hoverColor={'GRAY_BORDER'}
        />
        <Spacer size={16} direction={'horizontal'} />
        <ButtonNew
          onPress={onAddBeneficiaries}
          borderColor={'BLUE'}
          borderWidth={1}
          borderRadius={4}
          color={'BLUE'}
          title={'Add Beneficiaries'}
          titleColor={'WHITE'}
          disabled={fileName?.length === 0}
        />
      </Box>
    </div>
  )
}

const styles = {
  container: {
    borderStyle: 'dashed',
    height: '240px',
    width: '700px',
    paddingHorizontal: 'MEDIUM',
    borderWidth: 1,
    borderRadius: '4px',
    borderColor: '#0186B080' as ColorOptions,
    disabled: false,
    underlayColor: 'WHITE',
    align: 'center',
    justify: 'center',
    bg: '#0186B00A' as ColorOptions,
  } as BoxProps,
  addContainer: {
    width: '72px',
    height: '72px',
    borderRadius: '36px',
    bg: 'BLUE',
    align: 'center',
    justify: 'center',
  } as BoxProps,
}

export { BulkBeneficiaryFileSelector }
